import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ModuleErrorView } from 'src/app/shared/errors/module-error.model';

export interface ViajesFirmaSubmitState {
  tkt: string;
  submitting: boolean;
  savedOffline: boolean;
  serverConfirmed: boolean;
  error: ModuleErrorView | null;
}

@Injectable({ providedIn: 'root' })
export class ViajesFirmaStateService {
  private readonly stateSubject = new BehaviorSubject<ViajesFirmaSubmitState | null>(
    null
  );

  readonly state$ = this.stateSubject.asObservable();

  beginSubmit(tkt: string): void {
    this.stateSubject.next({
      tkt,
      submitting: true,
      savedOffline: false,
      serverConfirmed: false,
      error: null,
    });
  }

  markOffline(tkt: string): void {
    this.patch(tkt, { submitting: false, savedOffline: true, serverConfirmed: false });
  }

  markConfirmed(tkt: string): void {
    this.patch(tkt, {
      submitting: false,
      savedOffline: false,
      serverConfirmed: true,
      error: null,
    });
  }

  markError(tkt: string, error: ModuleErrorView): void {
    this.patch(tkt, { submitting: false, error });
  }

  clear(tkt?: string): void {
    if (!tkt || this.stateSubject.value?.tkt === tkt) {
      this.stateSubject.next(null);
    }
  }

  private patch(tkt: string, partial: Partial<ViajesFirmaSubmitState>): void {
    const current = this.stateSubject.value;
    if (!current || current.tkt !== tkt) {
      return;
    }
    this.stateSubject.next({ ...current, ...partial });
  }
}
